import { Box, HStack } from '@chakra-ui/react';
import { keyframes } from '@chakra-ui/system';
import { useEffect, useState } from 'react';

import Text from 'components/Text';

const LOADING_MESSAGES = [
  'Brewing a spell...',
  'Consulting the codex...',
  'Weaving incantations...',
  'Channeling arcane energy...',
  'Reading the scrolls...',
  'Decoding ancient runes...',
  'Mixing magical ingredients...',
  'Summoning pixel spirits...',
  'Enchanting your code...',
  'Casting transformation spell...',
  'Polishing the crystal ball...',
  'Aligning the stars...',
  'Gathering mana...',
  'Invoking the arcane arts...',
  'Studying the grimoire...',
  'Conjuring solutions...',
  'Transmuting logic...',
  'Whispering to the compiler...',
  'Forging digital runes...',
  'Unlocking hidden patterns...',
  'Distilling pure logic...',
  'Harmonizing the elements...',
  'Awakening dormant functions...',
  'Charting the code paths...',
  'Binding variables to fate...',
  'Scrying for edge cases...',
  'Infusing with creativity...',
  'Tuning the spell parameters...',
  'Weaving threads of logic...',
  'Summoning clean abstractions...',
  'Channeling best practices...',
  'Preparing the incantation...',
  'Meditating on the problem...',
  'Consulting fellow wizards...',
  'Refining the potion...',
  'Sketching the blueprint...',
  'Warming up the cauldron...',
  'Alchemizing your request...',
  'Tracing magical circuits...',
  'Manifesting the solution...',
  'Calibrating the wand...',
  'Deciphering the prophecy...',
  'Gathering arcane components...',
  'Spinning up enchantments...',
  'Navigating the spell tree...',
  'Transcribing the answer...',
  'Illuminating the path...',
  'Synthesizing the elements...',
  'Composing the final spell...',
  'Almost there...',
];

const pulse = keyframes`
  0%, 100% { opacity: 0.4; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
`;

const MerlinLoadingIndicator = () => {
  const [messageIndex, setMessageIndex] = useState(() =>
    Math.floor(Math.random() * LOADING_MESSAGES.length)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % LOADING_MESSAGES.length);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <HStack spacing={2}>
      <HStack spacing={1}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            w="5px"
            h="5px"
            borderRadius="full"
            bg="purple.400"
            animation={`${pulse} 1.4s ease-in-out ${i * 0.2}s infinite`}
          />
        ))}
      </HStack>
      <Text
        key={messageIndex}
        fontSize="micro"
        color="purple.300"
        fontStyle="italic"
        animation={`${fadeIn} 0.3s ease-out`}
      >
        {LOADING_MESSAGES[messageIndex]}
      </Text>
    </HStack>
  );
};

export default MerlinLoadingIndicator;
